var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"container"}},[_c('img',{attrs:{"src":require('/src/assets/hermes 1.png'),"alt":"logo","id":"image"}}),_c('h1',{attrs:{"id":"text1"},on:{"click":_vm.redirect}},[_vm._v("Sandesha")]),_c('h3',{attrs:{"id":"text2"}},[_vm._v("Creating your account")])])
}
var staticRenderFns = []

export { render, staticRenderFns }